import { Fragment, useEffect, useState } from "react";
import { useAuth } from "../../../../Context/AuthContext";
import { ImageWithDefault } from "../../../../Layout/Common/imageWithDefault";
import { Link } from "react-router-dom";
import { ViewPdfButton } from "./viewPdfButton";
import { ViewEbookButton } from "./viewEbookButton";
import { BrowseOnlineButton } from "./browseOnlineButton";

export const ListViewItem = ({ row }) => {
  const { isAuthenticated } = useAuth();
  const [item, setItem] = useState(null);
  const [pdfLink, setPdfLink] = useState("");
  const baseDirectory = process.env.REACT_APP_publicUrl || window.location.origin;
  useEffect(() => {
    setItem(row);
  }, [row]);
  return (
    <Fragment>
      {item && (
        <div className="col-md-12 mb-3">
          <div className="card catalogue-card newFlyer-row">
            <div className="newFlyer-rowImg">
              <Link className="catalogue-img">
                <ImageWithDefault
                  src={"https://cdn.wes.com.au/prodimages" + item.imageFile}
                  alt={item.categoryName}
                  classList="w-100"
                />
              </Link>
              <div className="wesFlyerDetails-title">
                <h5 className="card-title">
                  <Link to={item.urlPath}>
                    {String(item.categoryName || "").length > 52
                      ? `${String(item.categoryName).slice(0, 52)}...`
                      : item.categoryName}
                  </Link>
                </h5>
                <p className="card-text">
                  <span className="newFlyer-date">{item.modifiedDate}</span>
                  <span>{item.categoryId}</span>
                </p>
              </div>
            </div>
            <div className="card-body wesFlyerDetails-bodyCard">
              <div className="wesFlyer-btns">
                <ViewPdfButton item={item} />
                <ViewEbookButton item={item} />
              </div>
              <BrowseOnlineButton item={item} />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
